import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ObjectenService } from 'src/app/shared/dataservices/objecten.service';
import { FactuurService } from 'src/app/shared/dataservices/factuur.service';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
import { Factuur, FactuurObject } from 'src/app/shared/model/factuur';
import { ActiveContactPersoon, ObjectRelatieGegevens } from 'src/app/shared/model/relatie';
import {Location} from '@angular/common';
import { utils, write, WorkBook } from 'xlsx';
import {saveAs } from 'file-saver'
import { GeneralFunctionsService } from 'src/app/shared/general-functions.service';
import { SelectAdresComponent } from 'src/app/relaties/select-adres/select-adres.component';


@Component({
  selector: 'app-factuur-edit',
  templateUrl: './factuur-edit.component.html',
  styleUrls: ['./factuur-edit.component.less']
})
export class FactuurEditComponent implements OnInit {

  factuur : Factuur = null;
  objecten: Array<FactuurObject> = null;
  @Input() factuurID : number;
  @Output() factuurAdded =  new EventEmitter<Factuur>();
  routeid = 0;
  relatiegegevens : ObjectRelatieGegevens;




  constructor(private relatiesService: RelatiesService,
              private objectenService: ObjectenService,
              private dialog: MatDialog,
              private factuurService: FactuurService,
              private activatedRoute: ActivatedRoute,
              private location: Location,
              private functions: GeneralFunctionsService,
              private toastr: ToastrService
    ) { }

  ngOnInit(): void {
      this.routeid = Number(this.activatedRoute.snapshot.paramMap.get('id'));
      if (this.routeid) {
        this.factuurService.getFactuur(this.routeid).subscribe(data => {
          this.factuur =  data;
          this.factuurID = data.ID;
          this.loadData();
        })
      }

  }

  loadData() {

    this.factuurService.getRelatieGegevens( this.factuur.ObjectID).subscribe(data=>{
      this.relatiegegevens = data;
      console.log(data)
    })
    this.location.go("/factuur/"+ this.factuur.ID);

  }


  ngOnChanges(changes: SimpleChanges) {
    if (!this.factuurID) return
    //if routeid is not set (No id in the URL) load the default, else we where loaden in ngOnInit
    if (this.routeid === 0) {
      this.factuurService.getFactuur(this.factuurID).subscribe(data => {
        this.factuur =  data;
        this.loadData();
      })
    } else {
      this.routeid = 0;
    }
  }


  totaalbedragInkoop() {
    return this.factuur.TotaalBedragEuro;
  }

  sanitizeNumber(event: any) :number {
    try {
      if (event) {
        let num : number = Number(event.replace(",","."));
        return num;
      }
    } catch (e) {
      console.log(e)
    }
    return 0;
  }

  save() {
    if (this.factuurID == null) {
      this.factuurService.postFactuur(this.factuur).subscribe((data) => {
        if (data.error) {
            this.handleError(data.error);
            return;
        }
        this.factuurID = data.id;
        this.factuur.ID = data.id;
        this.toastr.info("", "Opgeslagen");
        this.factuurAdded.emit(this.factuur);
      } )
    } else {
      this.factuurService.saveFactuur(this.factuurID,this.factuur).subscribe(() => {
        this.toastr.info("", "Opgeslagen");
      } )

    }
  }
  add() {
    if (this.objecten == null) {
      this.factuurService.getObjecten().subscribe(data => {
        this.objecten =  data;
      })
    }
    this.factuurID = null;
    this.factuur = new Factuur();
    this.factuur.ID = 0;

  }

  handleError(data: any) {
    try {
      this.toastr.error("", data.originalError.info.message, {timeOut: 0});
    }catch(e) {

    }
  }

  delete() {

  }

  excel() {
    let dialogRef = this.dialog.open(SelectAdresComponent, {
      height: '600px',
      width: '600px',
      data: {relatieid: this.relatiegegevens.BedrijfNummer, adresid: 0}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == undefined) return;
      const adresid = result.adresid;
      this.factuurService.postRapport(this.factuur.ID, adresid).subscribe(result => {
        try {
          console.log(result);
          const ws_name = 'factuur';
          const wb: WorkBook = { SheetNames: [], Sheets: {} };
          const ws: any = utils.json_to_sheet(result);
          wb.SheetNames.push(ws_name);
          wb.Sheets[ws_name] = ws;
          const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type:'binary' });
          console.log(wbout);
          saveAs(new Blob([this.functions.s2ab(wbout)],{type:"application/octet-stream"}), 'factuur.xlsx');
        } catch (E) {
          console.log(E);
        }
      })
    });
  }


}
